import { Outlet } from 'react-router';

import { FloatingNavBar, Header } from '@/components/common';

const MainLayout = () => {
  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <Header />
      <main className="flex-1 pt-[70px]">
        <div className="mx-8 mt-10 mb-[125px]">
          <Outlet />
        </div>
      </main>
      <FloatingNavBar />
    </div>
  );
};

export default MainLayout;
